/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

  // Calendar Labels
  // eventLabels: [],

  // Simple Calendar State
  // events: [],

  events: [
    // {
    //   id: 1,
    //   title: 'My Event',
    //   startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 3),
    //   endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 2),
    //   url: '',
    //   classes: 'event-success',
    //   label: 'business'
    // }
  ],
  eventLabels: [
    {
      text: 'Business',
      value : 'business',
      color: 'success'
    },
    {
      text: 'Work',
      value: 'work',
      color: 'warning'
    },
    {
      text: 'Personal',
      value: 'personal',
      color: 'danger'
    },
    {
      text: 'Primary',
      value: 'primary',
      color: 'primary'
    }
  ]
}
